import type { FC, CSSProperties } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { EmptyTitle } from 'app/components/Text';
import Button from 'app/components/Button';

import style from './style.scss';

interface Props {
  title?: string;
  retryLabel?: string;
  onRetry: () => void;
  className?: string;
  style?: CSSProperties;
  titleClassName?: string;
  pandaUser?: boolean;
}

const ErrorView: FC<Props> = ({
  title,
  retryLabel,
  onRetry,
  className,
  style: css,
  titleClassName,
  pandaUser
}) => {
  const [t] = useTranslation();

  return (
    <div className={classnames(style.container, className)} style={css}>
      <EmptyTitle className={titleClassName}>{title || t('error-title')}</EmptyTitle>
      <Button onClick={onRetry} className={style.button}>
        {retryLabel || t('error-reload_page')}
      </Button>
      {pandaUser ? (
        <div className={style.message}>{t('error-if_problem_persist_team')}</div>
      ) : (
        <div className={style.message}>
          {t('error-if_problem_persist')}{' '}
          <a className={style.link} href="mailto:support@pandaodds.co">
            support@pandaodds.co
          </a>
        </div>
      )}
    </div>
  );
};

ErrorView.displayName = 'ErrorView';

export default ErrorView;
